import { OmniMaisV2RestService } from './../../omni-rest/omni-mais/omni-mais-v2-rest.service';
import { OmniMaisRestService } from './../../omni-rest/omni-mais/omni-mais-rest.service';
import { HttpStatus } from './../../omni-rest/http-status';
import { catchError } from 'rxjs/operators';
import { Observable, of, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { OferecePj } from '../models/oferece-pj.interface';
import { FichaVeiculoPjRestServiceService } from './ficha-veiculo-pj-rest-service.service';
import { DadoSimulacaoPj } from '../models/dado-simulacao-pj';
import { OmniGeralRestService } from './../../omni-rest/omni-geral/omni-geral-rest.service';
import { NaturezaJuridicaPj } from '../models/natureza-juridica-pj.interface';
import { RecuperaDadosPJ } from '../models/recupera-dados.interface';
import { ResponseRecuperaDadosCNPJ } from '../models/responseRecuperaDadosCNPJ.interface';
import { HttpParams } from '@angular/common/http';
import { AssistanceTypeResponse } from '../../ficha-veiculo/ficha-cadastro/ficha-cadastro-resultado-parcial/model/proposta/assistance-types';
import { OmniAssistenciaService } from '../../omni-rest/omni-assistencia/omni-assistencia.service';
import { AllAssistances } from '../models/all-assistances';
import { InsuranceGroupsResponse } from '../models/insurance-groups';
import { OmniSeguroService } from '../../omni-rest/omni-seguro/omni-seguro.service';
import { AllInsurances } from '../models/all-insurances';

@Injectable({
  providedIn: 'root',
})
export class FichaVeiculoPjService {
  constructor(
    private readonly fichaVeiculoPjRestServiceService: FichaVeiculoPjRestServiceService,
    private readonly omniRestService: OmniMaisRestService,
    private readonly omniGeralRestService: OmniGeralRestService,
    private readonly restServiceV2: OmniMaisV2RestService,
    private readonly omniAssistenciaService: OmniAssistenciaService,
    private readonly omniSeguroService: OmniSeguroService
  ) { }

  getOffersByPersonType(agente: number): Observable<OferecePj> {
    return this.fichaVeiculoPjRestServiceService.get(
      `agent/${agente}/person-type`
    );
  }

  simular(payload: any) {
    return this.fichaVeiculoPjRestServiceService.post(
      'proposta/simular',
      payload
    );
  }

  getDadosProposta(idProposta: string): Observable<any> {
    return this.fichaVeiculoPjRestServiceService
      .get(`proposta/${idProposta}/dados`)
      .pipe(
        catchError((error, source) => {
          if (error.status === HttpStatus.BAD_REQUEST) {
            return of(error.error);
          }
          return throwError(error);
        })
      );
  }

  finalizarSimulacao(payload: any) {
    return this.fichaVeiculoPjRestServiceService.post(
      'proposta/finalizarSimulacao',
      payload
    );
  }

  simulacaoDetalhe(simulacao: DadoSimulacaoPj, parcelas?: number) {
    let url =
      `proposta/${simulacao.getNumeroProposta()}/simulacao/detalhe` +
      `?ultimaDataTaxa=${simulacao.getUltimaDataTaxa()}` +
      `&retorno=${simulacao.getSeguro().getRetorno()}` +
      `&carencia=${simulacao.getCarencia()}` +
      `&entradaPorcentagem=${simulacao.getEntradaPorcentagem()}` +
      `&parcelas=${parcelas || 0}`;

    if (simulacao.getValor() && simulacao.getValor() > 0) {
      url = `${url}&valorLiberado=${simulacao.getValor()}`;
    } else {
      url = `${url}&valorLiberado=0`;
    }

    if (
      simulacao.getSeguro().getGrupoSeguroIds() != null &&
      simulacao.getSeguro().getGrupoSeguroIds().length
    ) {
      simulacao
        .getSeguro()
        .getGrupoSeguroIds()
        .map((elem) => elem.seguroId)
        .forEach((item) => {
          url = `${url}&seguroId=${item}`;
        });
    } else {
      url = `${url}&seguroId=-1`;
    }

    if (
      simulacao
        .getSeguro()
        .getGrupoAssistenciaIds()
        .some(
          (grupoAssistencia) => grupoAssistencia && grupoAssistencia.length > 0
        )
    ) {
      simulacao
        .getSeguro()
        .getGrupoAssistenciaIds()
        .map((grupoAssistencia) => grupoAssistencia)
        .forEach((grupoAssistencia) => {
          grupoAssistencia.forEach((element) => {
            if (element !== undefined && element !== null) {
              url = `${url}&assistenciaId=${element.assistenciaId}`;
            } else {
              url = `${url}&assistenciaId=-1`;
            }
          });
        });
    } else {
      url = `${url}&assistenciaId=-1`;
    }
    return this.restServiceV2.get(url);
  }

  recuperarDadosFicha(cnpj: string, idlojista) {
    return this.omniRestService.get(
      `veiculo/recuperar-dados/${cnpj}?lojista=${idlojista}`
    );
  }

  produtosPorUsuario(tipoOperacao, idAgente: number, tipoCliente?: number) {
    const url = tipoCliente
      ? `operacao/produtos-por-usuario/${tipoOperacao}?agenteId=${idAgente}&tipoCliente=${tipoCliente}`
      : `operacao/produtos-por-usuario/${tipoOperacao}?agenteId=${idAgente}`;
    return this.fichaVeiculoPjRestServiceService.get(url);
  }

  getNaturezaJuridica(): Observable<NaturezaJuridicaPj[]> {
    return this.omniGeralRestService.get('natureza-juridica');
  }

  getAllTipoAssistencia(): Observable<AssistanceTypeResponse> {
    return this.omniAssistenciaService.get('assistance-type');
  }

  getAllAssistencias(productType: string): Observable<AllAssistances> {
    const params = new HttpParams().append('productTypes', productType);
    return this.omniAssistenciaService.get('assistance/agent', { params });
  }

  putRecuperaDados(body: RecuperaDadosPJ): Observable<RecuperaDadosPJ> {
    return body && body.propostaId
      ? this.fichaVeiculoPjRestServiceService.post('proposta/retrieve', {
        ...body,
      })
      : of({} as RecuperaDadosPJ);
  }

  getRecuperaDados(propostaId: number): Observable<RecuperaDadosPJ> {
    return propostaId
      ? this.fichaVeiculoPjRestServiceService.get(
        `proposta/retrieve/${propostaId}`
      )
      : of({} as RecuperaDadosPJ);
  }

  getAllGrupoSeguro(): Observable<InsuranceGroupsResponse> {
    return this.omniSeguroService.get('simulation/insurance-group');
  }

  getAllSeguros(): Observable<AllInsurances> {
    return this.omniSeguroService.get('seguro/find');
  }

  getRecuperaDadosPorCNJP(
    cnpj: string,
    idLojista
  ): Observable<ResponseRecuperaDadosCNPJ> {
    return cnpj
      ? this.fichaVeiculoPjRestServiceService.get(
        `proposta/retrieve-form-data/${idLojista}/${cnpj}`
      )
      : of({});
  }
}
